require('../styles/app.scss');

import constants  from '../constants/episodesConstants';
import Menu from './Menu';
import React from 'react';
import { Link } from 'react-router';

class AppComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  componenentWillMount(){

  }

  render() {
    return (
      <div className="app-container">
        <header id="header">
          <Menu currentEpisodeId={this.props.currentEpisodeId} length={constants.nEpisode} />
        </header>
        {this.props.children} {/* cf index.js: other nodes are nested in Route rendering AppComponent */}
        <footer>
          <div className="container">
            <div>
              <a target="cmf-fmc.ca" href="http://www.cmf-fmc.ca/fr-ca" className="fmc-logo">Fonds des médias du Canada</a>
              <a target="unis.ca" href="http://unis.ca" className="unis-logo">UnisTV</a>
              <a target="balestra.tv" href="http://fr.balestra.tv" className="balestra-logo">Balestra</a>
              <a target="lvlstudio.com" href="http://lvlstudio.com/fr" className="lvl-logo">LVL Studio</a>
            </div>

            <Link to={'/Credits'} className="credits-link" >Crédits</Link>
          </div>
        </footer>
      </div>
    );
  }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/App.js